import { SB } from '@play-co/replicant';

const weeklyLeaderboardEntry = SB.object({
  /** User score in this event */
  score: SB.int(),
  /** Timestamp when the user joined the event */
  joinedAt: SB.int(),
  /** List of opponents ids */
  opponents: SB.array(SB.string()),
  /** Last user position user has seen */
  position: SB.int().optional(),
  /** Timestamp when the user claimed this event */
  claimedAt: SB.int().optional(),
});

export type WeeklyLeaderboardEntry = SB.ExtractType<
  typeof weeklyLeaderboardEntry
>;

export const weeklyLeaderboardSchema = {
  weeklyLeaderboard: SB.object({
    /** Map of events that user has participated in */
    entries: SB.map(weeklyLeaderboardEntry),
    /** Last time user has seen the weekly leaderboard */
    lastSeenAt: SB.int().optional(),
  }).optional(),
};
